<template>

	<app-boards board-key="guide_function"></app-boards>

</template>

<script>
import AppBoards from "@/components/boards/appBoards";
export default {
	name: "guide_function",
	components: {AppBoards}
}
</script>

<style scoped>

</style>